import { render, staticRenderFns } from "./PayableRateArchivingDetailDetail.vue?vue&type=template&id=018add41&scoped=true"
import script from "./PayableRateArchivingDetailDetail.vue?vue&type=script&lang=js"
export * from "./PayableRateArchivingDetailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018add41",
  null
  
)

export default component.exports